import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import ROUTES from '../../config/routes';
import StartLayout from '../start-layout';

import Header from '../../packages/corporate-identity/header';
import CIBase from '../../packages/corporate-identity/base';

const CorporateIdentityLayout = () => {
  const { path } = useRouteMatch();

  return (
    <StartLayout>
      <CIBase>
        <Header />
        <Switch>
          <Route
            exact
            path={`${path}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_SOCIAL_MEDIA}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/social-media`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_WEB_IMAGES}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/web-images`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_BOOKMARKS}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/bookmarks`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_FLYERS}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/flyers`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_FOLDERS}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/folders`)
            )}
          />
          {/* <Route
            path={`${path}/${ROUTES.CI_IMAGES}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/images`)
            )}
          /> */}
          <Route
            path={`${path}/${ROUTES.CI_POSTCARDS}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/postcards`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_POSTERS}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/posters`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_PRESENTATIONS}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/keynotes`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_CHILDREN_GAMES}`}
            component={React.lazy(
              () => import(`../../packages/corporate-identity/children-games`)
            )}
          />
          <Route
            path={`${path}/${ROUTES.CI_IMAGE_BUTTON}`}
            component={React.lazy(() =>
              import(`../../packages/corporate-identity/image-button`)
            )}
          />
        </Switch>
      </CIBase>
    </StartLayout>
  );
};

export default CorporateIdentityLayout;
